import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Whitening.css';

const Whitening = () => {
    const pricing = [
        { type: "In-Office Teeth", price: "₱10,000 and UP" },
        { type: "Whitening (U/L)", price: "₱10,000 - ₱15,000" },
        { type: "At-Home Whitening (U/L)", price: "₱10,000 - ₱15,000" },
    ];

    return (
        <>
        <Header />
        <div className="whitening-container">
            <div className="whitening-content">
                <h1>WHITENING</h1>
                <p>
                Teeth whitening is a cosmetic dental procedure that lightens the color of teeth. 
                It's commonly used to remove stains caused by factors like coffee, tea, wine, smoking, or certain medications. 
                Whitening can be done professionally at a dentist's office or at home using over-the-counter products.
                </p>
                <h2>Pricing</h2>
                <table className="whitening-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};
export default Whitening;